import {
  claimOfflineOrder,
  claimOfflineOrderAndUpdateUser,
  validateOfflineOrderToken
} from "./chunk-KVUL37HD.mjs";

// src/hooks/wbk/booking/claimOrder.ts
import { useMutation } from "@tanstack/react-query";
var useValidateOfflineOrderToken = () => {
  return useMutation({
    mutationFn: validateOfflineOrderToken
  });
};
var useClaimOfflineOrderAndUpdateUser = () => {
  return useMutation({
    mutationFn: claimOfflineOrderAndUpdateUser
  });
};
var useClaimOfflineOrder = () => {
  return useMutation({
    mutationFn: claimOfflineOrder
  });
};

export {
  useValidateOfflineOrderToken,
  useClaimOfflineOrderAndUpdateUser,
  useClaimOfflineOrder
};
//# sourceMappingURL=chunk-DW4IFFZJ.mjs.map